import { Alert, Flex, Heading, Responsive, Table } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { Card } from "../../Card";
import CourseReviewEntry from "./CourseReviewEntry";

const CourseReviewList = ({ reviews, status, title, alertMessage }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Flex>
        <Flex.Item shouldGrow>
          <Heading level="h2">{title}</Heading>
        </Flex.Item>
      </Flex>
      <div style={{ borderBottom: "1px solid #ccc" }} />
      {reviews.length > 0 ? (
        <Responsive
          query={{ small: { maxWidth: "40rem" }, large: { minWidth: "41rem" } }}
          props={{ small: { layout: "stacked" }, large: { layout: "auto" } }}
        >
          {(props) => (
            <Table caption={title} margin="small 0 0 0" {...props}>
              <Table.Head>
                <Table.Row>
                  <Table.ColHeader id="review-cycle" width="33%">
                    {t("courseReview.reviewPeriod")}
                  </Table.ColHeader>
                  <Table.ColHeader id="actions" width="33%">
                    {t("actions.actions")}
                  </Table.ColHeader>
                </Table.Row>
              </Table.Head>
              <Table.Body>
                {reviews.map((review) => (
                  <CourseReviewEntry
                    key={review.id}
                    review={review}
                    status={status}
                  />
                ))}
              </Table.Body>
            </Table>
          )}
        </Responsive>
      ) : (
        <Alert margin="small 0 0 0">{alertMessage}</Alert>
      )}
    </Card>
  );
};

export default CourseReviewList;
